import { render, staticRenderFns } from "./softoa.vue?vue&type=template&id=070466c6&scoped=true&"
import script from "./softoa.vue?vue&type=script&lang=js&"
export * from "./softoa.vue?vue&type=script&lang=js&"
import style0 from "./softoa.vue?vue&type=style&index=0&id=070466c6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070466c6",
  null
  
)

export default component.exports